import { ApplicationConfig, provideBrowserGlobalErrorListeners, APP_INITIALIZER, APP_BOOTSTRAP_LISTENER } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { httpLoggingInterceptor } from './components/shared/services/http-logging.interceptor';
import { BannerPreloadService } from './services/banner-preload.service';
import { AppkitService } from './components/shared/services/appkit.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([httpLoggingInterceptor])),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      })
    ),
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (preloadService: BannerPreloadService, appkitService: AppkitService) => {
        return async () => {
          preloadService.preloadHomeBanner(); // Fire and forget in the background
          try {
            await Promise.race([
              appkitService.ready(),
              new Promise((_, reject) => setTimeout(() => reject(new Error('AppKit initialization timeout')), 5000))
            ]);
          } catch (error) {
            console.error('AppKit initialization failed or timed out, continuing bootstrap:', error);
          }
        };
      },
      deps: [BannerPreloadService, AppkitService]
    },
    {
      provide: APP_BOOTSTRAP_LISTENER,
      multi: true,
      useFactory: (preloadService: BannerPreloadService) => {
        return () => preloadService.dismissLoader();
      },
      deps: [BannerPreloadService]
    }
  ]
};
